import { useState, useEffect } from 'react';
import { getCompanyContext } from 'utils/setCompanyContext';
import { getReceivableTerm } from 'utils/receivableTerm';

function getCompanyTypeFromContext() {
  const context = getCompanyContext();
  const company = context?.companies?.[0];
  let type = company?.type ?? company?.company_type ?? null;
  if (type != null) return type;
  // Fallback: contexto antigo pode não ter type; buscar em dashboard_user.accessible_companies
  try {
    const savedUser = localStorage.getItem('dashboard_user');
    if (savedUser && company?.id != null) {
      const user = JSON.parse(savedUser);
      const accessible = user?.accessible_companies || [];
      const match = accessible.find((c) => c.id === company.id);
      type = match?.type ?? match?.company_type ?? null;
    }
  } catch (_) {}
  return type;
}

/**
 * Hook que retorna o termo de recebíveis (Títulos vs Mensalidades) conforme o tipo da empresa no contexto.
 * @returns {{ singular: string, plural: string, pluralLower: string }}
 */
export function useReceivableTerm() {
  const [term, setTerm] = useState(() => getReceivableTerm(getCompanyTypeFromContext()));

  useEffect(() => {
    const updateTerm = () => setTerm(getReceivableTerm(getCompanyTypeFromContext()));
    updateTerm();
    window.addEventListener('company-context-changed', updateTerm);
    window.addEventListener('company-changed', updateTerm);
    return () => {
      window.removeEventListener('company-context-changed', updateTerm);
      window.removeEventListener('company-changed', updateTerm);
    };
  }, []);

  return term;
}
